/* Mckwurst Designs catalog page: the print button. No dependencies.
   The button starts hidden in the markup and appears only when this script runs.
   Pictures are lazy loaded, so printing first loads every one of them. */
(function () {
  'use strict';

  function lazyImages() {
    return Array.prototype.slice.call(document.querySelectorAll('.catalog img[loading="lazy"]'));
  }

  /* Resolves once every picture has loaded, or after a few seconds, whichever comes first. */
  function loadAll() {
    var waits = lazyImages().map(function (img) {
      img.loading = 'eager';
      if (img.complete) return Promise.resolve();
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });
    return Promise.race([
      Promise.all(waits),
      new Promise(function (resolve) { window.setTimeout(resolve, 4000); })
    ]);
  }

  function init() {
    if (typeof window.print !== 'function') return;
    document.querySelectorAll('[data-catalog-print]').forEach(function (button) {
      if (button.hasAttribute('data-inited')) return;
      button.setAttribute('data-inited', '');
      button.hidden = false;
      button.addEventListener('click', function () {
        if (button.getAttribute('aria-disabled') === 'true') return;
        button.setAttribute('aria-disabled', 'true');
        loadAll().then(function () {
          button.removeAttribute('aria-disabled');
          window.print();
        });
      });
    });
  }

  /* Ctrl+P and the browser menu skip the button, so start loading as the print dialog opens. */
  window.addEventListener('beforeprint', loadAll);

  document.addEventListener('shopify:section:load', init);
  init();
})();
